import { Link } from 'react-router-dom';
import { getCategories } from '@/utils/video';

export default function SiteFooter() {
  const categories = getCategories();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-play-circle-fill text-2xl"></i>
              </span>
              <span className="text-lg font-bold text-background-50">宅男视频</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              聚合动画、游戏与影视片段的影音娱乐平台，专为宅男打造多样、快捷的观看体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容分类</h3>
            <ul className="flex flex-col gap-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/" className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">搜索视频</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">关注我们</h3>
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-800 text-background-50 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer" title="微博">
                <i className="ri-weibo-fill text-lg"></i>
              </span>
              <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-800 text-background-50 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer" title="B站">
                <i className="ri-bilibili-fill text-lg"></i>
              </span>
              <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-800 text-background-50 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer" title="YouTube">
                <i className="ri-youtube-fill text-lg"></i>
              </span>
            </div>
            <p className="text-xs text-primary-300 mt-4 leading-relaxed">
              本站为演示站点，站内视频与数据均为虚构内容，仅供界面展示。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300">© {year} 宅男视频 ZHAINAN.TV 保留所有权利</p>
          <p className="text-xs text-primary-300">演示用途 · 无登录 · 无支付 · 无真实播放</p>
        </div>
      </div>
    </footer>
  );
}